import { render } from "./AccessRequestAddressBook.vue?vue&type=template&id=ece116b2"
import script from "./AccessRequestAddressBook.vue?vue&type=script&lang=js"
export * from "./AccessRequestAddressBook.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__